import classNames from 'classnames';
import { RichTextEditor } from '../RichTextEditor';
import styles from './RichTextValue.module.scss';

export interface RichTextValueProps {
  label: string | false;
  className?: string;
  labelClassName?: string;
  value?: string;
  ownerId?: string;
  ownerType: string;
  scrollable?: boolean;
}

export function RichTextValue(props: RichTextValueProps) {
  const {
    ownerId,
    ownerType,
    label,
    className,
    labelClassName,
    value,
    scrollable = true,
  } = props;
  return (
    <div className={classNames(className, styles.container)}>
      {label && (
        <div className={classNames(labelClassName, styles.label)}>{label}</div>
      )}
      {
        <div className={styles.value}>
          {value && (
            <RichTextEditor
              value={value}
              disabled
              readonly
              bordered={false}
              ownerId={ownerId}
              ownerType={ownerType}
              className={scrollable ? undefined : styles.richTextEditor}
              contentWrapperClassName={
                scrollable ? undefined : styles.richTextContentWrapper
              }
              editorInputClassName={
                scrollable ? undefined : styles.richTextInput
              }
            />
          )}
        </div>
      }
    </div>
  );
}
